import { CustomKeyAttributes } from '@loyalty/shared-common/profile-api-client';
import { Fields } from '@react-awesome-query-builder/core';
import { BaseConfigSettings } from '../fields';
import { excludedOperators } from '../settings';
import { profileFields } from './profile-fields';

export function qualifioAdvancedFormatPrediction(
  settings: BaseConfigSettings,
  customKeys?: CustomKeyAttributes[],
): Fields {
  const { t } = settings;
  return {
    event: {
      label: t('rule.criteria.event'),
      type: '!group',
      subfields: {
        matchExternalId: {
          label: t('rule.criteria.advanced-format.prediction.match'),
          type: 'text',
          excludeOperators: excludedOperators,
          valueSources: ['value'],
        },
        leagueExternalId: {
          label: t('rule.criteria.advanced-format.prediction.league'),
          type: 'text',
          excludeOperators: excludedOperators,
          valueSources: ['value'],
        },
        result: {
          label: t('rule.criteria.advanced-format.prediction.result'),
          type: 'select',
          excludeOperators: excludedOperators,
          valueSources: ['value'],
          fieldSettings: {
            listValues: [
              { value: 'INCORRECT', title: 'Incorrect' },
              { value: 'CORRECT_WINNER', title: 'Correct winner' },
              { value: 'CORRECT_SCORE', title: 'Correct score' },
            ],
          },
        },
        timestamp: {
          label: settings.t('rule.criteria.date'),
          type: 'datetime',
          preferWidgets: ['date'],
        },
      },
    },
    profile: {
      label: t('rule.criteria.profile'),
      type: '!group',
      subfields: profileFields(settings, customKeys),
    },
  };
}
